import React from 'react';
import { Frown } from 'react-feather';
import styled from 'styled-components';
import { media } from 'theme';
import { Colors } from 'app/seedly-component-library';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 36px;
  width: 660px;

  ${media.largeAndDown`
    width: 100%;
  `}
`;

const TopBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;

  ${media.largeAndDown`
    padding: 0px 15px;
  `}
`;

const Title = styled.p`
  font-weight: bold;
  font-size: 18px;

  ${media.largeAndDown`
    font-size: 14px;
  `}
`;

const SeeAll = styled.p`
  font-size: 16px;
  cursor: pointer;

  ${media.largeAndDown`
    font-size: 14px;
  `}
`;

const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const ResultListContainer = styled.div``;

const MainText = styled.p`
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
  color: ${props => props.theme.colors.neutral5};
`;

const SubText = styled.p`
  font-size: 14px;
  margin-top: 10px;
  color: ${props => props.theme.colors.neutral5};
`;

const BottomSeeAll = styled.p`
  font-size: 14px;
  color: ${props => props.theme.colors.neutral7};
  margin-top: 14px;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
`;

const ErrorContainer = ({ type }) => {
  return (
    <ErrorWrapper>
      <Frown size={106} color={Colors.neutral5} />
      <MainText>Oops! No {type} Found</MainText>
      <SubText>Try changing your search term?</SubText>
    </ErrorWrapper>
  );
};

const SearchListWrapper = props => {
  const { type, term, onSeeAllClick, count = 0 } = props;
  const haveSeeAll = onSeeAllClick && count > 3;

  return (
    <Container>
      {count > 0 && (
        <TopBar>
          <Title>
            {count} {type} matching &quot;{term}&quot;
          </Title>
          {haveSeeAll && (
            <SeeAll onClick={() => onSeeAllClick()}>See all</SeeAll>
          )}
        </TopBar>
      )}
      {count === 0 ? (
        <ErrorContainer type={type} openPostModal={props.openPostModal} />
      ) : (
        <ResultListContainer>{props.children}</ResultListContainer>
      )}
      {haveSeeAll && (
        <BottomSeeAll onClick={() => onSeeAllClick()}>
          See {count} {type}
        </BottomSeeAll>
      )}
    </Container>
  );
};

export default SearchListWrapper;
